import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { pick } from '@eastcoal/common/utils/object'

import { useAuctionListStore } from '../../../Store/hooks/useStore'
import { DealNoticeBatchDownloadModal } from '../DealNoticeBatchDownloadModal'

export const DealNoticeBatchDownloadButton = () => {
  const { selectedRowKeys } = useRemoteTableStore(state =>
    pick(state, ['selectedRowKeys'])
  )
  const { toggleDealNoticeBatchDownloadModalVisible } = useAuctionListStore(
    state => pick(state, ['toggleDealNoticeBatchDownloadModalVisible'])
  )

  const handleShowModal = () => {
    toggleDealNoticeBatchDownloadModalVisible(true)
  }

  return (
    <>
      <ThrottleButton
        disabled={!selectedRowKeys.length}
        type='primary'
        onClick={handleShowModal}
      >
        成交通知书批量下载
      </ThrottleButton>
      <DealNoticeBatchDownloadModal />
    </>
  )
}
